import { useState, useEffect } from "react";
import { useGetAllModulesQuery } from "../services/ModuleServices";

const useModules = () => {
  const [modules, setModules] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllModulesQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setModules(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { modules, isDataLoading };
};

export default useModules;
